import { z } from 'zod';
import { IdSchema, IsoDateTimeSchema, nullableText, optionalText, requiredText } from './common.js';
import { parseBannerLink } from './banner-link.js';
// Havola yordamchilari zod'siz alohida faylda (Mini App'ga zod tushmasligi uchun, `money-format` kabi).
export * from './banner-link.js';
/** `linkUrl` maydoni uchun: faqat to'g'ri havola formati qabul qilinadi. */
const BannerLinkValueSchema = z
    .string()
    .trim()
    .max(255)
    .refine((value) => parseBannerLink(value) !== null, {
    message: "Havola noto'g'ri: product:<slug>, category:<id>, catalog yoki search:<matn>",
});
/**
 * Bosh sahifadagi banner.
 *
 * Ko'rsatish oynasi (`startsAt`/`endsAt`) SERVERDA tekshiriladi:
 * klient soatiga ishonib bo'lmaydi va telefon vaqti noto'g'ri
 * qo'yilgan mijoz eskirgan aksiyani ko'rib qolardi.
 */
export const BannerResponseSchema = z.object({
    id: IdSchema,
    titleUz: z.string(),
    titleRu: nullableText(120),
    subtitleUz: nullableText(200),
    subtitleRu: nullableText(200),
    badgeUz: nullableText(40),
    badgeRu: nullableText(40),
    imageUrl: nullableText(255),
    /** Dizayn tizimidagi kategoriya rangi: engine, brakes, oils, ... */
    colorKey: nullableText(32),
    linkUrl: nullableText(255),
    startsAt: IsoDateTimeSchema.nullable(),
    endsAt: IsoDateTimeSchema.nullable(),
    sort: z.number().int(),
    isActive: z.boolean(),
});
export const CreateBannerSchema = z
    .object({
    titleUz: requiredText(120),
    titleRu: optionalText(120),
    subtitleUz: optionalText(200),
    subtitleRu: optionalText(200),
    badgeUz: optionalText(40),
    badgeRu: optionalText(40),
    imageUrl: optionalText(255),
    colorKey: optionalText(32),
    linkUrl: BannerLinkValueSchema.optional(),
    startsAt: IsoDateTimeSchema.optional(),
    endsAt: IsoDateTimeSchema.optional(),
    sort: z.number().int().min(0).max(9999).optional(),
})
    .strict()
    .refine((v) => v.startsAt === undefined || v.endsAt === undefined || v.startsAt < v.endsAt, {
    message: "Boshlanish sanasi tugash sanasidan oldin bo'lishi kerak",
    path: ['endsAt'],
});
export const UpdateBannerSchema = z
    .object({
    titleUz: requiredText(120).optional(),
    titleRu: z.string().trim().max(120).nullable().optional(),
    subtitleUz: z.string().trim().max(200).nullable().optional(),
    subtitleRu: z.string().trim().max(200).nullable().optional(),
    badgeUz: z.string().trim().max(40).nullable().optional(),
    badgeRu: z.string().trim().max(40).nullable().optional(),
    imageUrl: z.string().trim().max(255).nullable().optional(),
    colorKey: z.string().trim().max(32).nullable().optional(),
    linkUrl: BannerLinkValueSchema.nullable().optional(),
    startsAt: IsoDateTimeSchema.nullable().optional(),
    endsAt: IsoDateTimeSchema.nullable().optional(),
    sort: z.number().int().min(0).max(9999).optional(),
    isActive: z.boolean().optional(),
})
    .strict();
//# sourceMappingURL=banner.js.map